import { useMemo } from 'react';
import { useAppSelector } from './useAuth';
import { getHubId } from '../utils/cookieUtils';

interface FilterableItem {
  id?: string;
  hubmasterid?: string | number;
  hubid?: string | number;
  [key: string]: any;
}

export const useRoleBasedFiltering = <T extends FilterableItem>() => {
  const { user } = useAppSelector((state) => state.auth);
  const userHubId = getHubId();
  const isSuperAdmin = user?.roleid === 1;

  const filterByRole = useMemo(() => {
    return (items: T[], idField: 'id' | 'hubmasterid' | 'hubid' = 'id'): T[] => {
      
      if (isSuperAdmin) {
        return items;
      } else if (userHubId !== null) {
        const filtered = items.filter(item => {
          let itemHubId: string | number | null = null;
          
          if (idField === 'id') {
            itemHubId = item.id || null;
          } else if (idField === 'hubmasterid') {
            itemHubId = item.hubmasterid || null;
          } else if (idField === 'hubid') {
            itemHubId = item.hubid || null;
          }
          
          const itemHubIdStr = itemHubId?.toString();
          const userHubIdStr = userHubId.toString();
          
          return itemHubIdStr === userHubIdStr;
        });
        
        return filtered;
      } else {
        return [];
      }
    };
  }, [isSuperAdmin, userHubId, user?.roleid]);

  return {
    filterByRole,
    isSuperAdmin,
    userHubId
  };
};

export default useRoleBasedFiltering;
